"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCT_BADGE_DEFAULT_COLORS = exports.PRODUCT_BADGES = void 0;
const PRODUCT_BADGES = exports.PRODUCT_BADGES = {
  best_fit: 'Best fit badge',
  best_price: 'Best price badge',
  best_fit_for_price: 'Best fit-for-price badge'
};
const PRODUCT_BADGE_DEFAULT_COLORS = exports.PRODUCT_BADGE_DEFAULT_COLORS = {
  best_fit: '#023E8A',
  best_price: '#D62828',
  best_fit_for_price: '#4C956C'
};